import {AgentIcon} from '@primer/octicons-react'
import {AnchoredOverlay, Button, Text} from '@primer/react'
import {type FC, useId, useState} from 'react'
import {FIX_DISABLED_SWE_AGENT_TEXT} from './FixFindingStatus'

interface FindingsHeaderProps {
  displayedCount: number
  handleFix: () => void
  sweAgentEnabled: boolean
}

function InactiveFixButton({reason}: {reason: string}) {
  const [open, setOpen] = useState(false)
  const reasonId = useId()
  return (
    <>
      <AnchoredOverlay
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        renderAnchor={props => (
          <Button {...props} size="small" leadingVisual={AgentIcon} inactive aria-describedby={reasonId}>
            Fix with Copilot
          </Button>
        )}
        side="outside-bottom"
        align="end"
        width="medium"
      >
        <Text as="p" className="p-3 m-0">
          {reason}
        </Text>
      </AnchoredOverlay>
      <span id={reasonId} className="sr-only">
        {reason}
      </span>
    </>
  )
}

export const FindingsHeader: FC<FindingsHeaderProps> = ({displayedCount, handleFix, sweAgentEnabled}) => {
  let disabledReason: string | undefined
  if (!sweAgentEnabled) {
    disabledReason = FIX_DISABLED_SWE_AGENT_TEXT
  } else if (displayedCount === 0) {
    disabledReason = 'No findings to fix'
  }

  return (
    <div className="d-flex flex-items-center flex-justify-between tmp-mb-3">
      <h2 id="findings-heading" className="f4" tabIndex={-1}>
        Findings
      </h2>
      {disabledReason ? (
        <InactiveFixButton reason={disabledReason} />
      ) : (
        <Button size="small" leadingVisual={AgentIcon} onClick={handleFix}>
          Fix with Copilot
        </Button>
      )}
    </div>
  )
}
